<!-- tap on top starts-->
<button class="tap-top" (click)="tapToTop()"
        [ngStyle]="{ 'display': show ? 'block' : 'none' }"
        aria-label="Scroll to top">
    <app-feather-icons [icon]="'chevrons-up'"></app-feather-icons>
</button>
<!-- tap on tap ends-->